module.exports = __webpack_public_path__ + "static/media/Wales.45d85521.png";